import React from 'react'
import Configuration from '../Configuration'

const SIBLING_PLUGINS = [
  {
    title: 'Payment Gateway Per Product',
    url: 'https://wordpress.org/plugins/woocommerce-product-payments/',
    desc: 'Show the right payment methods per product, category, or tag.',
  },
  {
    title: 'Shipping Gateway Per Product',
    url: 'https://wordpress.org/plugins/woocommerce-shipping-gateway-per-product/',
    desc: 'Control shipping methods per product, category, or tag.',
  },
]

const Sidebar = () => {
  const config = Configuration.getInstance()

  return (
    <aside className="dreamfox-info-sidebar">
      <div className="dreamfox-info-card">
        <h3>Dreamfox Media</h3>
        <p>Reliable WooCommerce plugins trusted by store owners since 2014.</p>
        <ul className="dreamfox-info-links">
          <li><a href="https://dreamfoxmedia.com/" target="_blank" rel="noopener noreferrer">Website</a></li>
          <li><a href="https://dreamfoxmedia.com/plugins" target="_blank" rel="noopener noreferrer">All plugins</a></li>
          <li><a href={config.kb_url} target="_blank" rel="noopener noreferrer">Knowledge base</a></li>
          <li><a href={config.contact_url} target="_blank" rel="noopener noreferrer">Get help / support</a></li>
          <li><a href="https://dreamfoxmedia.com/contact/" target="_blank" rel="noopener noreferrer">Contact us</a></li>
        </ul>
      </div>

      <div className="dreamfox-info-card dreamfox-info-card--muted">
        <h3>More plugins by Dreamfox Media</h3>
        <ul className="dreamfox-info-plugin-list">
          {SIBLING_PLUGINS.map((plugin) => (
            <li key={plugin.url}>
              <a href={plugin.url} target="_blank" rel="noopener noreferrer">{plugin.title}</a>
              <span>{plugin.desc}</span>
            </li>
          ))}
        </ul>
      </div>
    </aside>
  )
}

export default Sidebar
